(function ($) {
	'use strict';

	$(function () {
		// Use custom plus and minus buttons to change quantity value

		$('.js-qty-minus, .js-qty-plus').on('click', function () {
			const $qty = $(this).parent('.quantity').find('.qty');
			const val = parseFloat($qty.val());
			const max = parseFloat($qty.attr('max'));
			const min = parseFloat($qty.attr('min'));
			const step = parseFloat($qty.attr('step'));

			if ($(this).is('.js-qty-plus')) {
				if (max && (max <= val)) {
					$qty.val(max).change();
				} else {
					$qty.val(val + step).change();
				}
			} else {
				if (min && (min >= val)) {
					$qty.val(min).change();
				} else if (val > 1) {
					$qty.val(val - step).change();
				}
			}
		});
	});
})(jQuery);
